import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';
export function WorkOrientationInputs() {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    internalState: '',
    response: '',
    context: ''
  });
  const handleOptionSelect = (field: string, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const handleNext = () => {
    if (currentStep === 1 && !formData.internalState) return;
    if (currentStep === 2 && !formData.response) return;
    if (currentStep === 3 && !formData.context) return;
    if (currentStep < 3) {
      setCurrentStep(currentStep + 1);
    } else {
      // Navigate to work snapshot output
      navigate('/work-snapshot-output');
    }
  };
  const internalStateOptions = ['Performance pressure', 'Authority tension', 'Team conflict', 'Decision blockage', 'Visibility or exposure'];
  const responseOptions = ['Over-deliver or compensate', 'Explain or justify', 'Hold back or wait', 'Push harder', 'Disengage internally'];
  const contextOptions = ['Authority dynamics', 'Performance pressure', 'Team conflict', 'Decision blockage', 'Visibility or exposure'];
  return <>
      <Helmet data-id="element-4402">
        <title data-id="element-4403">Quick Decode — Work | Lazy Monk Labs</title>
        <meta name="robots" content="noindex, nofollow" data-id="element-4404" />
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5] flex flex-col" data-id="element-4405">
        <header data-id="element-4406">
          <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A]/95 backdrop-blur-sm border-b border-[#2B2B2B]" data-id="element-4407">
            <div className="max-w-7xl mx-auto px-6 py-4" data-id="element-4408">
              <p className="text-xs text-[#F5F5F5]/50 text-center tracking-wider" data-id="element-4409">
                Step {currentStep} of 3
              </p>
            </div>
          </nav>
        </header>

        <main className="flex-1 flex items-center justify-center px-6 pt-20 pb-16" data-id="element-4410">
          <div className="max-w-2xl mx-auto w-full" data-id="element-4411">
            {currentStep === 1 && <div data-id="element-4412">
                <h1 className="text-3xl md:text-4xl font-medium mb-12 text-center leading-tight tracking-tight" data-id="element-4413">
                  What feels most true about this work situation?
                </h1>
                <div className="space-y-4 mb-12" data-id="element-4414">
                  {internalStateOptions.map((option, index) => <label key={index} className={`block border p-6 cursor-pointer transition-colors ${formData.internalState === option ? 'border-[#F5F5F5] bg-[#F5F5F5]/5' : 'border-[#2B2B2B] hover:border-[#F5F5F5]/30'}`} data-id="element-4415">
                      <input type="radio" name="internalState" value={option} checked={formData.internalState === option} onChange={e => handleOptionSelect('internalState', e.target.value)} className="sr-only" data-id="element-4416" />
                      <span className="text-base" data-id="element-4417">{option}</span>
                    </label>)}
                </div>
                <button onClick={handleNext} disabled={!formData.internalState} className="w-full px-8 py-5 bg-[#F5F5F5] text-[#0A0A0A] font-semibold text-sm tracking-widest uppercase hover:bg-[#F5F5F5]/90 transition-colors shadow-lg disabled:opacity-30 disabled:cursor-not-allowed" data-id="element-4418">
                  Continue
                </button>
              </div>}

            {currentStep === 2 && <div data-id="element-4419">
                <h1 className="text-3xl md:text-4xl font-medium mb-12 text-center leading-tight tracking-tight" data-id="element-4420">
                  What do you typically do when this happens?
                </h1>
                <div className="space-y-4 mb-12" data-id="element-4421">
                  {responseOptions.map((option, index) => <label key={index} className={`block border p-6 cursor-pointer transition-colors ${formData.response === option ? 'border-[#F5F5F5] bg-[#F5F5F5]/5' : 'border-[#2B2B2B] hover:border-[#F5F5F5]/30'}`} data-id="element-4422">
                      <input type="radio" name="response" value={option} checked={formData.response === option} onChange={e => handleOptionSelect('response', e.target.value)} className="sr-only" data-id="element-4423" />
                      <span className="text-base" data-id="element-4424">{option}</span>
                    </label>)}
                </div>
                <button onClick={handleNext} disabled={!formData.response} className="w-full px-8 py-5 bg-[#F5F5F5] text-[#0A0A0A] font-semibold text-sm tracking-widest uppercase hover:bg-[#F5F5F5]/90 transition-colors shadow-lg disabled:opacity-30 disabled:cursor-not-allowed" data-id="element-4425">
                  Continue
                </button>
              </div>}

            {currentStep === 3 && <div data-id="element-4426">
                <h1 className="text-3xl md:text-4xl font-medium mb-12 text-center leading-tight tracking-tight" data-id="element-4427">
                  What kind of work situation does this show up in most?
                </h1>
                <div className="space-y-4 mb-12" data-id="element-4428">
                  {contextOptions.map((option, index) => <label key={index} className={`block border p-6 cursor-pointer transition-colors ${formData.context === option ? 'border-[#F5F5F5] bg-[#F5F5F5]/5' : 'border-[#2B2B2B] hover:border-[#F5F5F5]/30'}`} data-id="element-4429">
                      <input type="radio" name="context" value={option} checked={formData.context === option} onChange={e => handleOptionSelect('context', e.target.value)} className="sr-only" data-id="element-4430" />
                      <span className="text-base" data-id="element-4431">{option}</span>
                    </label>)}
                </div>
                <button onClick={handleNext} disabled={!formData.context} className="w-full px-8 py-5 bg-[#F5F5F5] text-[#0A0A0A] font-semibold text-sm tracking-widest uppercase hover:bg-[#F5F5F5]/90 transition-colors shadow-lg disabled:opacity-30 disabled:cursor-not-allowed" data-id="element-4432">
                  See Quick Decode
                </button>
              </div>}
          </div>
        </main>
      </div>
    </>;
}